import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Icon from 'tbk-components/src/components/Icon';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IMegaMenuProps extends IBaseElementProps {
	children?: any;
}

export interface IMegaMenuCallout {
	heading?: string;
	description?: string;
}

export interface IMegaMenuSideBar {
	image?: IImage;
	heading?: string;
	leadInText?: string;
	description?: string;
	link?: ILink;
}

export interface IMegaMenuLink {
	image?: IImage;
	link?: ILink;
	/**
	 * @control textarea
	 */
	description?: string;
}

export interface IMegaMenuProps extends IBaseElementProps {
	links?: IMegaMenuLink[];
	numColumns?: '3' | '4' | '5';
	callout?: IMegaMenuCallout;
	sideBar?: IMegaMenuSideBar;
}

/**
 * Mega Menu
 * @block
 * @icon welcome-widgets-menus
 */
const MegaMenu: React.FC<IMegaMenuProps> = ({
	children,
	className,
	classNames = [],
	links = [],
	numColumns = '4',
	callout,
	sideBar,
}) => (
	<div className={className || cn('mega-menu-container', ...classNames)}>
		{callout && (
			<div className="mega-menu__callout-container">
				<div className="mega-menu__callout">
					{callout.heading && <h3>{callout.heading}</h3>}
					{callout.description && <p>{callout.description}</p>}
				</div>
			</div>
		)}
		<div className={`mega-menu__content mega-menu__content--${numColumns}`}>
			{links.length > 0 && (
				<div className="mega-menu__links">
					{links.map((link, index) => (
						<div key={index} className="mega-menu__link">
							<a href={link.link?.href}>
								{link.image && (
									<Image
										className="mega-menu__link__image"
										{...link.image}
									/>
								)}
								<span className="mega-menu__link__button">
									{link.link?.label}
								</span>

								{link.description && (
									<div className="mega-menu__link__description">
										{link.description}
									</div>
								)}
							</a>
						</div>
					))}
				</div>
			)}
		</div>
		{sideBar && (
			<div className="mega-menu__sidebar">
				{sideBar.image && (
					<Image
						className="mega-menu__sidebar__image"
						{...sideBar.image}
					/>
				)}
				{sideBar && (
					<div className="mega-menu__sidebar__content">
						{sideBar.heading && (
							<h4 className="mega-menu__sidebar__heading">
								{sideBar.heading}
							</h4>
						)}
						{sideBar.description && (
							<p className="mega-menu__sidebar__description">
								<span className="mega-menu__sidebar__lead">
									{sideBar.leadInText}{' '}
								</span>
								{sideBar.description}
							</p>
						)}
						{sideBar.link && (
							<Button
								className="btn btn-primary mega-menu__sidebar__button"
								{...sideBar.link}
							/>
						)}
					</div>
				)}
			</div>
		)}
	</div>
);

export default MegaMenu;
